import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'GuestPage' | 'OfferCard';

/**
 * Errors related to the Treats Rewards page
 */
export const Errors = createErrors<Page, Component>('TreatsRewards')({
    GuestPage: {
        GetTreatsPageGuest: {
            severity: 'MEDIUM',
            message: 'Failed to fetch Treats Rewards page content for guest',
        },
    },
    OfferCard: {
        ActivateOfferFailed: {
            severity: 'HIGH',
            message: 'Failed to activate an offer',
        },
    },
});
